<div>
  <header class="appHeader navi">
    <a href="/" class="logo white"></a>
  </header>

  <nav class="appNav navi whiteT">
    <div class="band appTitle inNav secondaryBG marBot40">
      <div class="wrap">
        <h3>SimpleCitizen for Business</h3>

      </div>
    </div>
  </nav>


  <div class="mainBody">
    <article class="band">
      <div class="wrap" [ngSwitch]="focus">
        <section class="pageTitle tAlignLeft" *ngSwitchDefault>
          <h1 class="primaryT w300">Welcome to SimpleCitizen</h1>
          <p>Let's create your SimpleCitizen Business Account. To get started, please confirm the
            following information so we can set up your account correctly.</p>
          <form #f="ngForm" (ngSubmit)="setNewPassword()">
            <label class="marTop40 twoColumn">
              <input type="password" id="setNewPasswordText" name="setNewPasswordText"
                     class="radius field"
                     [class.is-empty]="!setNewPasswordText"
                     [(ngModel)]="setNewPasswordText"
                     #createPassword="ngModel"
                     required/>
              <span><span>New Password <em class="required">*</em></span></span>
            </label>

            <label class="marTop40 twoColumn">
              <input type="password" id="setRetypeNewPasswordText" name="setRetypeNewPasswordText"
                     class="radius field"
                     [class.is-empty]="!setRetypeNewPasswordText"
                     [(ngModel)]="setRetypeNewPasswordText"
                     required/>
              <span><span>Verify <em class="required">*</em></span></span>
            </label>
            <p class="redT">{{errorMsg}}</p>

            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                [disabled]="!f.valid"
                class="button primary radius dropShadow marTop20 left"
                type="submit">
                Save Password
              </button>
            </section>
          </form>
        </section>
        <section class="pageTitle tAlignLeft" *ngSwitchCase="'changecompanyinfo'">
          <h1 class="primaryT w300">Welcome to SimpleCitizen</h1>
          <p>Let's create your SimpleCitizen Business Account. To get started, please confirm the
            following information so we can set up your account correctly.</p>
          <form #f="ngForm" (ngSubmit)="saveCompanyInfo()">
            <label class="marTop40 twoColumn">
              <input type="text" id="firstName" name="firstName" class="radius field"
                     [class.is-empty]="!firstName"
                     [(ngModel)]="firstName"
                     required/>
              <span><span>First Name <em class="required">*</em></span></span>
            </label>
            <label class="marTop40 twoColumn">
              <input type="text" id="lastName" name="lastName" class="radius field"
                     [class.is-empty]="!lastName"
                     [(ngModel)]="lastName"
                     required/>
              <span><span>Last Name <em class="required">*</em></span></span>
            </label>
            <label class="marTop40 twoColumn">
              <input type="text" id="companyName" name="companyName" class="radius field"
                     [class.is-empty]="!companyName"
                     [(ngModel)]="companyName"
                     required/>
              <span><span>Full Company Name<em class="required">*</em></span></span>
            </label>
            <label class="marTop40 twoColumn">
              <input type="email" id="emailAddress" name="emailAddress" class="radius field"
                     [class.is-empty]="!emailAddress"
                     [(ngModel)]="emailAddress"
                     disabled/>
              <span><span>Work Email Address<em class="required">*</em></span></span>
            </label>

            <p class="redT" *ngIf="errorMsg">{{errorMsg}}</p>

            <section class="buttonGroupBottom tAlignCenter clearfix">
              <button
                class="button primary radius dropShadow marTop20 left"
                type="submit">
                Save Information
              </button>
            </section>
          </form>
        </section>
      </div>
    </article>
  </div>
</div>
